import { render, staticRenderFns } from "./input-over-10w.vue?vue&type=template&id=1281f8eb&scoped=true&"
import script from "./input-over-10w.vue?vue&type=script&lang=js&"
export * from "./input-over-10w.vue?vue&type=script&lang=js&"
import style0 from "./input-over-10w.vue?vue&type=style&index=0&id=1281f8eb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1281f8eb",
  null
  
)

export default component.exports